import { Dialog, DialogType, Spinner } from "@fluentui/react";
import { IOpenPanel } from "../../../../Interfaces/IPanel";
import { useEffect, useState } from "react";
import { HistoricoEstadoEquipoService } from "../../../../services/auxiliar/HistoricoEstadoEquipo";
import { IDetalleEquipo } from "../../../../Interfaces/estadoEquipos/IEstadoEquipo";

interface IDetalleEquipoReporte  extends IOpenPanel{
    HistoricoId:string
}
export const DetalleEquipoReporte=(props:IDetalleEquipoReporte)=>{
    const modelProps = {
        isBlocking: true,
        topOffsetFixed: true,
      }
      const dialogContentProps = {
        type: DialogType.normal,
        title: 'Detalle de Equipo',
        subText: '',
      };
    const [info,setInfo]=useState<IDetalleEquipo>();
    const [loading,setLoading]=useState<boolean>(false)
    useEffect(()=>{
        if(!props.isOpen){
            setLoading(true)
            HistoricoEstadoEquipoService.InfoHistorico(props.HistoricoId).then((res)=>{
              setInfo(res.data)
              setLoading(false)
            }).catch((e)=>{
                setLoading(false)
            })
        }
    },[props.isOpen])
    return(
    <Dialog hidden={props.isOpen} onDismiss={props.onDismiss} modalProps={modelProps}  dialogContentProps={dialogContentProps}>
     {loading ? (<Spinner></Spinner>):(<>
      <p>Equipo: {info?.equipo}</p>
      <p>Modelo: {info?.modelo}</p>
      <p>Tipo: {info?.tipo}</p>
      <p>Turno: {info?.turno}</p>
      <p>Operador: {info?.operador}</p>
      <p>Estado: {info?.estado}</p>
      <p>Razón: {info?.razon}</p>
      <p>Horometro: {info?.horometro}</p>
      <p>Combustible: {info?.combustible}</p></>)}
    </Dialog>)
}